module.exports = __webpack_public_path__ + "assets/images/logo_circonopoly.8766b90.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/credits/logo_circonopoly.png
// module id = 894
// module chunks = 1